export default __webpack_public_path__ + "static/media/cu.f36b07ef.svg";